<p [class.estimated-value]="estimatedValue" [class.no-result]="!estimatedValue" *ngIf="!loading">
  {{estimatedValue ? (estimatedValue | currency:'CAD':'symbol-narrow':'1.0-0') : ' N/A'}}
</p>
